import { isBoolean, merge, noop } from 'es-toolkit';
import { ADS_VIDEO_VPAID_MODE, PARTNER_ADS_CONFIG } from '../constants';
import { api } from '../singletons';
class AppSessionDataProvider {
    #data = { breadcrumbId: '' };
    #readyPromise = Promise.withResolvers();
    #consentDataPromise;
    get ready() {
        return Promise.all([this.#consentDataPromise, this.#readyPromise.promise]).then(noop);
    }
    get isInDiscordIframe() {
        return this.#data.isInDiscordIframe || false;
    }
    get hasAdConfig() {
        const { providers } = api.getConfigSetting(PARTNER_ADS_CONFIG) || {};
        return providers?.google || providers?.adswizz;
    }
    get adOptions() {
        const { providers } = api.getConfigSetting(PARTNER_ADS_CONFIG) || {};
        return {
            providers,
            providerOptions: {
                ...this.#data.adConfig,
                ...(this.consentData?.isTargetingEnabled && {
                    ppid: api.adsTargeting?.ppid,
                }),
                vpaidMode: api.getConfigSetting(ADS_VIDEO_VPAID_MODE, 'disabled'),
                // TODO: WMP's default ad loader timeout is good enough for now, but we can create a setting later if we need to
                // adLoaderTimeout: api.getConfigSetting<number>(AD_LOADER_TIMEOUT),
            },
            privacyData: this.consentData,
        };
    }
    get consentData() {
        return this.#data.consentData || {};
    }
    get streamsConsentParams() {
        const { audiences, usPrivacyString, gdprTcString, gdprApplies, optedInGeneralVendorIds } = this.consentData;
        const params = {
            us_privacy: usPrivacyString,
            audience: audiences ? `;${audiences.join(';')};` : undefined,
        };
        // gdprApplies is undefined until OneTrust determines whether GDPR applies
        // IMPORTANT: GDPR ATTRIBUTE MUST BE STRING
        if (isBoolean(gdprApplies)) {
            params.gdpr = gdprApplies ? '1' : '0';
        }
        if (gdprTcString) {
            params.gdpr_consent = gdprTcString;
        }
        if (optedInGeneralVendorIds) {
            params.genVendors = optedInGeneralVendorIds;
        }
        return params;
    }
    get breadcrumbId() {
        return this.#data.breadcrumbId || '';
    }
    get env() {
        return this.#data.env || 'prod';
    }
    get currentScreen() {
        return this.#data.currentScreen || '';
    }
    async init(data) {
        await this.update(data);
        this.#readyPromise.resolve();
    }
    // Only accept consent data on init(), since we resolve its promise there
    async update(data) {
        if (!data) {
            return;
        }
        this.#data = merge(this.#data, data);
        if (data.consentDataPromise) {
            this.#consentDataPromise = data.consentDataPromise;
            this.#data.consentData = await this.#consentDataPromise;
        }
    }
}
export const appSessionDataProvider = new AppSessionDataProvider();
